import {Stack, Typography} from '@mui/material';
import {ProjectContext} from '@context/ProjectContext';
import {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import ServicesIcon from '@icons/ServicesIcon';

export default function ServicesButton(props: any) {
	const {t} = useTranslation();
	const {shahadat} = useContext(ProjectContext);
	const isActive = !!props['aria-selected'];

	return (
		<Link to="/services" {...props}>
			<Stack direction="column" alignItems="center" spacing={0.5}>
				<ServicesIcon active={isActive}/>
				<Typography fontSize={12} sx={{color: shahadat && isActive ? '#000' : undefined}}>
					{t('services')}
				</Typography>
			</Stack>
		</Link>
	);
}
